import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tw-bg-white tw-rounded-xl tw-p-4 tw-mb-5" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex\"><button id=\"openNoteModalTc\" class=\"btn tw-bg-[#FF0000] tw-text-[#FFFFFF] tw-rounded-lg fw-bold ms- mb-1\" style=\"border:none;\" data-bs-toggle=\"modal\" data-bs-target=\"#note-Modal-FindA\">SEE NOTE</button></div><div class=\"modal\" id=\"note-Modal-FindA\" tabindex=\"-1\" aria-hidden=\"true\" aria-labelledby=\"label-modal-1\"><div class=\"modal-dialog modal-dialog-centered\"><div class=\"modal-content\"><div class=\"modal-body\"><h3 class=\"text-center\"><b>Note:</b></h3><br><p class=\"text-center\"> Before entering information in the &quot;Financing Information&quot; section, make sure to first complete and save the &quot;Realtor Form&quot; and &quot;Title Company&quot; sections. </p><br><div class=\"d-flex justify-content-end\"><button id=\"closeNoteModal\" type=\"button\" class=\"btn tw-bg-[#00a0da] tw-text-[#FFFFFF] tw-rounded-full tw-w-[150px]\" data-bs-dismiss=\"modal\" aria-label=\"Close\"> CLose </button></div></div></div></div></div><h2 class=\"tw-text-center tw-text-lg tw-text-[20px] tw-border-b-[2px] tw-border-[#b0b0b0] tw-pb-2\"> FIND A </h2>", 3)
const _hoisted_5 = { class: "tw-flex tw-justify-between tw-items-center tw-gap-5 tw-mt-3" }
const _hoisted_6 = { class: "tw-flex tw-flex-col tw-gap-2 tw-w-full" }

import { toRefs } from 'vue';
import CompanyTitle from './CompanyTitle.vue';
import Inspectors from './Inspectors.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FindA',
  props: {
  userSession: Object,
  selectedCompanyTitle: {
    type: Object,
    default: null
  },
  usingInspector: {
    type: Object,
    default: null
  },
  isInvestment: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:selectedCompanyTitle', 'update:usingInspector'],
  setup(__props, { emit }) {

const props = __props;




const { userSession, selectedCompanyTitle, usingInspector } = toRefs(props)

const handleCompanyTitleUpdate = (newCompanyTitle) => {
  emit('update:selectedCompanyTitle', newCompanyTitle);
};

const handleInspectorUpdate = (newInspector) => {
  emit('update:usingInspector', newInspector);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(CompanyTitle, {
            userSession: _unref(userSession),
            usingCompanyTitle: _unref(selectedCompanyTitle),
            isInvestment: __props.isInvestment,
            "onUpdate:usingCompanyTitle": handleCompanyTitleUpdate
          }, null, 8, ["userSession", "usingCompanyTitle", "isInvestment"])
        ])
      ])
    ])
  ]))
}
}

})